import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'decodeHtml' })
export class DecodeHtmlPipe implements PipeTransform {
	public transform(value: string): string {
		if (!value) return value;

		const textarea = document.createElement('textarea');
		textarea.innerHTML = value;

		return textarea.value;
	}
}
